import dayjs from 'dayjs'

const frontFormat = 'MM/DD/YYYY'
const backFormat = 'YYYY-MM-DDTHH:mm:ss'
const dateToString = (date) => dayjs(date).format(frontFormat).toString()
const saveDate = (date) => {
    //if date is not provided (undefined) will return current date
    return dayjs(date).format(backFormat)
}
const daysUntilDate = (date) =>
    Math.ceil(dayjs(date).diff(dayjs(), 'day', true))
const dateAfterDays = (days) => dayjs().add(days, 'day').$d

export { dateToString, saveDate, daysUntilDate, dateAfterDays }
